define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Orientation;
    (function (Orientation) {
        Orientation[Orientation["horizontal"] = 0] = "horizontal";
        Orientation[Orientation["vertical"] = 1] = "vertical";
    })(Orientation = exports.Orientation || (exports.Orientation = {}));
    var MediaEntry = (function () {
        function MediaEntry() {
            this.Filename = null;
            this.UploadAt = new Date();
            this.UploadedBy = null;
            this.Orientation = null;
            this.Url = null;
            this.Size = 0;
            this.ContentType = null;
        }
        return MediaEntry;
    }());
    exports.MediaEntry = MediaEntry;
    var MediaItem = (function () {
        function MediaItem() {
            this.Thumb = null;
            this.Displayname = null;
            this.Comment = null;
            this.TenantId = null;
            this.AssignedLocations = [];
            this.UploadedBy = null;
            this.LastChangeBy = null;
            this.UploadedAt = new Date();
            this.LastChangeAt = new Date();
            this.IsBackendItem = false;
            this.UploadSucceeded = false;
        }
        return MediaItem;
    }());
    exports.MediaItem = MediaItem;
});
//# sourceMappingURL=MediaItem.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Models/Media/MediaItem.js
// module id = 378
// module chunks = 0